const Backbone = require('backbone');
const _liveAgentInvitationPopup = require('common/_live_agent_invitation.dust');
const LiveAgentCustomPopupView = require('common/live_agent_custom_popup');
const ContactCenterModel = require('app/models/store/client/contact_center');
const omnitureHelper = require('app/views/store/common/omniture/omniture_helper');
const { proType, LIVE_AGENT_POPUP_TYPE, COMMUNICATION_METHOD } = require('lib/enums');

const proactiveChatDenyListCategories = [
	'Shower Accessories',
	'Plumbing Parts and Accessories',
	'Hardware Accessories',
	'Kitchen Accessories',
	'Cabinet Hardware Accessories',
	'HVAC Parts and Accessories',
	'Appliance Parts and Accessories',
	'Part'
];

module.exports = Backbone.View.extend({
	initialize: function(options = {}) {
		if (window.dataLayer && window.dataLayer.product) {
			// Only do this check if a product-business category is specified in the dataLayer.
			if (proactiveChatDenyListCategories.includes(window.dataLayer.product.businessCategory)) {
				// We are on a page where we should not send a proactive chat invitation.
				return;
			}
		}

		this.options = options;
		this.contactCenterModel = new ContactCenterModel({
			communicationMethod: COMMUNICATION_METHOD.CHAT,
			isCheckout: window.dataLayer.isCheckout
		});
		if (window.embedded_svc) {
			this._setLiveAgentDelay.call(this);
		} else {
			this.listenTo(Backbone, 'liveAgent:onLoad', () => {
				this._setLiveAgentDelay();
			});
		}
	},

	_setLiveAgentDelay: function() {
		if (!window.dataLayer || !window.embedded_svc) {
			return;
		}
		let startCountdown = false;
		// If we are on an Invitation Enabled page and the Invitation Delay is not 0 we begin a countdown to opening
		// the Live Agent window automatically
		if (window.dataLayer.startProactiveChat) {
			if (window.dataLayer.salesforce.invitationDelay !== 0) {
				startCountdown = true;
			}
		}
		const isOwnedPro = window.dataLayer.customer && window.dataLayer.customer.proType === proType.OWNED;
		if (window.dataLayer.contactCenterHoursInfo.isChatOpen && !window.BCOM.device.isMobile && startCountdown && !isOwnedPro) {
			const invitationDelay = window.dataLayer.enableProactiveChatCartDelayTest ? 45000 : window.dataLayer.salesforce.invitationDelay;
			setTimeout(this._sendInvitation.bind(this), invitationDelay);
		}
	},

	_sendInvitation: function() {
		const myStorage = window.localStorage;
		const sendInvitation = this._checkInvitationDeclinedStatus(myStorage);

		// Only open chat window if it's defined and hasn't been declined in past 48 hours
		if (typeof window.embedded_svc.inviteAPI !== 'undefined' && sendInvitation) {
			try {
				const liveChatButton = $('.uiButton.helpButtonEnabled');
				// Don't load if no agents online
				if (liveChatButton.length === 1) {
					myStorage.setItem('chat_last_opened_by', 'invitation');
					window.embedded_svc.inviteAPI.inviteButton.acceptInvite();
				}
			} catch (e) {
				// Calling inviteAPI always throws an unneeded SF error.  This suppresses it.
			}
			this._checkContactCenterHours();
		}
	},
	_checkContactCenterHours: function() {
		this.contactCenterModel
			.fetch()
			.then(() => {
				const isOpen = this.contactCenterModel.get('isOpen');
				if (isOpen) {
					this._renderInvitePopup();
				}
			})
			.catch(window.clientErrorHandler);
	},
	_renderInvitePopup() {
		this.liveAgentCustomPopupView = new LiveAgentCustomPopupView({
			type: LIVE_AGENT_POPUP_TYPE.PROACTIVE,
			template: _liveAgentInvitationPopup
		});
		Backbone.trigger(
			'omniture:chatTracking',
			`livechatproactiveinvited~${omnitureHelper._chatTrackingMessage(
				window.s.pageName,
				window.dataLayer.baseCategory,
				omnitureHelper._getBusinessCategory()
			)}`,
			'proactiveinvited',
			window.s.pageName,
			window.dataLayer.baseCategory,
			omnitureHelper._getBusinessCategory()
		);
	},
	_checkInvitationDeclinedStatus: function(myStorage) {
		const ttlDateString = myStorage.getItem('invitation_declined_ttl');
		if (ttlDateString) {
			const ttlDate = new Date(ttlDateString);
			if (ttlDate >= new Date()) {
				// It's not been 48 hours since the user last closed an invitation
				return false;
			}
		}
		return true;
	}
});
